
WB.WidgetGrids = WB.WidgetGrids || {};

WB.WidgetGrids.WidgetGridDefaultDirectiveLink = function (scope, element, attr) {
};

WB.WidgetGrids.WidgetGridDefaultDirective = function () {
    return {
        scope: {
            grid: '='
        },
        restrict: 'AE',
        link: WB.WidgetGrids.WidgetGridDefaultDirectiveLink,
        template: `<ul class="widget-grid js-widget-grid" data-layout-id="{{ grid.LayoutId }}">
        <div
            ng-repeat="widget in grid.Widgets"
            wb-widget-grid-widget-item
            widget="widget"></div>
    </ul>`
    };
};
WB.App.directive('wbWidgetGridDefault', WB.WidgetGrids.WidgetGridDefaultDirective);
